import { DEFAULT_COMPARE_TO_PREVIOUS_PERIOD } from '@modules/quantify/constants';
import { QuantifyQuery } from '@modules/quantify/store/types';

export const getPreviousPeriodValueAndUnitForOptionLabel = (
  compareTo: QuantifyQuery['compareQuery'],
  duration: QuantifyQuery['duration'],
) => {
  if (compareTo?.previousPeriod) {
    return {
      value: compareTo.previousPeriod.value,
      unit: compareTo.previousPeriod.unit,
    };
  }

  if (duration?.type === 'last') {
    return {
      value: duration.value,
      unit: duration.unit,
    };
  }

  return {
    unit: DEFAULT_COMPARE_TO_PREVIOUS_PERIOD.previousPeriod.unit,
    value: DEFAULT_COMPARE_TO_PREVIOUS_PERIOD.previousPeriod.value,
  };
};
